import {State} from '../types/state'

export const isRequestPending = (state: State, requestName: string) =>
  Boolean(state.pendingRequests.requestNames.find(name => name === requestName))
